import clsx from "clsx";
import React, { useContext } from "react";
import { LanguageContext, text } from "../../container/language";
import Paragraph from "../Article/Paragraph";
import Paragraphs from "../Article/Paragraphs";

export const Alert = ({ data }) => {
  const { title, content, type } = data;
  const color = clsx(
    { success: type === "SUCCESS" },
    { warning: type === "WARNING" },
    { danger: type === "DANGER" }
  );

  const { userLanguage } = useContext(LanguageContext);

  return (
    <div className={`promo-box editable ${color}`}>
      <Paragraphs className={color} data={content} />

      <div className={`promo-box__label ${color}`}>
        <font>
          <font>{text(title, userLanguage)}</font>
        </font>
      </div>
    </div>
  );
};

export default Alert;
